import { Grid } from "@mantine/core";
import { GoogleLogin } from "@react-oauth/google";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { StoreContext } from "../stores/rootStore";
import { notifications } from "@mantine/notifications";

const Login: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const rs = useContext(StoreContext);

  return (
    <Grid>
      <Grid.Col>
        <h1>Login</h1>
      </Grid.Col>
      <Grid.Col>
        <GoogleLogin
          onSuccess={(credentialResponse) => {
            rs.googleAuthStore.credential = credentialResponse.credential;
            notifications.show({
              title: "Authenticated!",
              message: "Authenticated with Google.",
              color: "green",
            });
            navigate(location.state.from);
          }}
          onError={() => {
            console.log("Login Failed");
            notifications.show({
              title: "Failed to authenticate!",
              message: "Failed to authenticate with google.",
              color: "red",
            });
          }}
          auto_select
        />
      </Grid.Col>
    </Grid>
  );
};

export default Login;
